import React, { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Box, CssBaseline, AppBar, Toolbar, IconButton, Typography, Switch, Drawer, List, ListItem, ListItemText, Avatar, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem, Menu, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import BarChart from "@mui/icons-material/BarChart";
import ChatPopup from "./ChatPopup"; // Import a chat popup component
import BarChartComponent from "./BarChartComponent"; // Import a bar chart component

const MateriaUiDasTest = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            School Management Dashboard
          </Typography>
          <Switch checked={darkMode} onChange={() => setDarkMode(!darkMode)} />
          <IconButton color="inherit" onClick={handleProfileMenuOpen}>
            <Avatar alt="Profile" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
          >
            <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleProfileMenuClose}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer open={sidebarOpen} onClose={toggleSidebar}>
        <Box sx={{ width: 250 }}>
          <List>
            <ListItem button>
              <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Students" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Teachers" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Classes" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      <Box sx={{ marginTop: 8, padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Card sx={{ flex: 1, minWidth: 200 }}>
            <CardContent>
              <Typography variant="h5">Students</Typography>
              <Typography variant="h6">1200</Typography>
            </CardContent>
          </Card>
          <Card sx={{ flex: 1, minWidth: 200 }}>
            <CardContent>
              <Typography variant="h5">Teachers</Typography>
              <Typography variant="h6">75</Typography>
            </CardContent>
          </Card>
          <Card sx={{ flex: 1, minWidth: 200 }}>
            <CardContent>
              <Typography variant="h5">Classes</Typography>
              <Typography variant="h6">50</Typography>
            </CardContent>
          </Card>
        </Box>

        <Box sx={{ marginTop: 4 }}>
          <Typography variant="h6">Performance Chart</Typography>
          <BarChartComponent />
        </Box>

        <Box sx={{ marginTop: 4 }}>
          <Typography variant="h6">Student Details</Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Grade</TableCell>
                  <TableCell>Section</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>John Doe</TableCell>
                  <TableCell>10</TableCell>
                  <TableCell>A</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Jane Smith</TableCell>
                  <TableCell>9</TableCell>
                  <TableCell>B</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={() => setIsChatOpen(true)}
          startIcon={<ChatBubbleOutlineIcon />}
          sx={{ position: "fixed", bottom: 16, right: 16 }}
        >
          Chat
        </Button>
        {isChatOpen && <ChatPopup onClose={() => setIsChatOpen(false)} />}
      </Box>
    </ThemeProvider>
  );
};

export default MateriaUiDasTest;
